import { useState, useEffect, useRef } from 'react';
import { ActionButton, AltButton } from '../../common/Buttons/Buttons';
import { Header } from '../../common/Header/Header.jsx';
import {
    CxCTable,
    PAPCommissionTable
} from '../../common/Tables/Tables';
import {
    PAPComissionTableHeader,
    AffiliationComissions
} from '../../../assets/helpers/tables';
import { notify } from '../../../assets/helpers/toast';
import { membershipService } from '../../../services/membershipService';
import { saleChannelService } from '../../../services/saleChannelService';
import { papService } from '../../../services/papService';
import { useHistory } from 'react-router-dom';
import {
    Select,
} from '../../common/Forms/Input/Input';
import { LoadSpinner } from '../../common/LoadSpinner/LoadSpinner.jsx';
import moment from 'moment';
import {
    filterParams,
} from '../../../assets/helpers/funciones';
import { monthsComissionsOptions } from '../../../assets/helpers/options.js';


const exportFilter = {
    PAP_COMMISSION: 'Comisiones PAP',
    AFF_COMMISSION: 'Comisiones Afiliaciones',
};

export const FilterButton = (props) => {
    const { label, type, action } = props;
    if (label === exportFilter?.RCV_Report && !type) {
        return <ActionButton label={label} action={() => action(label)} />;
    }
    if (label === type) {
        return <ActionButton label={label} action={() => action(label)} />;
    } else {
        return <AltButton label={label} action={() => action(label)} />;
    }
};

export const PAPComissions = () => {
    const tableRef = useRef(null);
    const history = useHistory();

    const [isLoading, setIsLoading] = useState(false);
    const [otpCode, setOtpCode] = useState('');


    const [salesChannelOptions, setSalesChannelOptions] = useState([]);
    const [month, setMonth] = useState(moment().month() + 1);
    const [year, setYear] = useState(moment().year());
    const [saleChannel, setSaleChannel] = useState('');

    const [membershipsDatatable, setMembershipsDatatable] = useState({
        offset: 0, //Elementos que ya pasaron la pagina
        data: [],
        count: 0, //Cantidad de elementos
        page: 1,
        dateFrom: '',
        dateTo: '',
        isLoading: false,
        searchParam: '',
        type: exportFilter?.PAP_COMMISSION,
    });

    const selectType = (type) => {
        if (type === membershipsDatatable?.type) {
            return null;
        }


        setMembershipsDatatable((prevState) => {
            return {
                ...prevState,
                page: 1,
                offset: 0,
                data: [],
                count: 0,
                type: type,
                searchParam: '',
                // isLoading: true,
            };
        });
    };


    const handlePageChange = (event, value) => {
        setMembershipsDatatable((prevState) => {
            return {
                ...prevState,
                page: value,
                offset: (value - 1) * membershipsDatatable?.limit,
            };
        });
    };


    const selectMonth = (e) => {
        const { value } = e?.target;
        setMonth(value);
    };


    const selectYear = (e) => {
        const { value } = e?.target;
        setYear(value);
    };

    const selectSaleChannel = (e) => {
        const { value } = e?.target;
        setSaleChannel(value);
    }


    const redirectToDetail = (a) => {
        history.push(`/dashboard/pap-affiliated/${month}/${year}/${a?.saleChannelId}`);
    };

    const redirectToCommissionDetail = (d) => {
        history.push(
            `/dashboard/pap-affiliated/commissions/details/${month}/${year}/${d?._id?.channel}`
        );
    };

    const renewMembership = (membership) => {
        if (!isLoading) {
            setIsLoading(true);
            membershipService
                .reativateMembership(membership?._id)
                .then((response) => {
                    if ([200, 201].includes(response?.status)) {
                        setIsLoading(false);
                        notify(`Membresia reactivada`, 'success');
                    } else {
                        setIsLoading(false);
                        notify(`${response.message}`, 'error');
                    }
                })
                .catch(() => { });
        }
    };


    useEffect(() => {
        getSalesChannel()
    }, []);

    useEffect(() => {
        getData();
    }, [
        membershipsDatatable?.page,
        membershipsDatatable?.offset,
        membershipsDatatable?.type,
        membershipsDatatable?.limit,
        month,
        year,
        saleChannel
    ]);

    const getSalesChannel = () => {
        saleChannelService
            .getSalesChannel()
            .then((response) => {
                if ([200, 201].includes(response?.status)) {
                    setSalesChannelOptions([{ _id: "", name: "" }, ...response?.data?.saleChannels]);
                } else {
                    notify(`${response.message}` || 'error', 'error');
                }
            })
            .catch(() => { });
    };

    const getAccountsReceivable = (byMail) => {
        const dateFrom = moment(`${year}-${month}-01`).format('MM-DD-YYYY');

        let params = {
            date: month && year ? dateFrom : '',
            saleChannel: saleChannel,
            byMail: byMail || false,
        };

        papService
            .getPAPCommissions(filterParams(params))
            .then((response) => {
                if (response.status === 200) {
                    if (!byMail) {
                        setMembershipsDatatable((prevState) => {
                            return {
                                ...prevState,
                                data: response?.data?.comissions,
                                count: response?.data?.total,
                                isLoading: false,
                            };
                        });
                    } else {
                        setOtpCode('');
                        notify(
                            `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
                            'info'
                        );
                    }
                } else {
                    notify(`${response.message}` || 'error', 'error');
                }
            })
            .catch(() => { });
    };


    const getAffAccountsReceivable = (byMail) => {

        let params = {
            year: year || '',
            month: month || '',
            channel: saleChannel,
            byMail: byMail || false,
        };

        papService
            .getPAPAffiliationCommissions(filterParams(params))
            .then((response) => {
                if (response.status === 200) {
                    if (!byMail) {
                        setMembershipsDatatable((prevState) => {
                            return {
                                ...prevState,
                                data: response?.data?.comissions,
                                count: response?.data?.total,
                                isLoading: false,
                            };
                        });
                    } else {
                        setOtpCode('');
                        notify(
                            `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
                            'info'
                        );
                    }
                } else {
                    notify(`${response.message}` || 'error', 'error');
                }
            })
            .catch(() => { });
    };


    const getData = (byMail) => {

        if (
            [exportFilter?.PAP_COMMISSION].includes(membershipsDatatable?.type)
        ) {
            getAccountsReceivable(byMail);
        }
        if (
            [exportFilter?.AFF_COMMISSION].includes(membershipsDatatable?.type)
        ) {
            getAffAccountsReceivable(byMail);
        }
    };
    return (
        <>
            <LoadSpinner show={membershipsDatatable?.isLoading || isLoading} />
            <Header />
            <div className="service-with-container container">
                <div className="buttons-container">
                    <h1 className="title-component">
                        Plan de Asistencia Primaria: {membershipsDatatable?.count}
                    </h1>

                    <div className="buttons-center-container">
                        <ActionButton
                            label={'Exportar'}
                            action={() => getData(true)}
                        />
                    </div>
                </div>
                <div className="breadcrumb-container">
                    <div></div>
                    <div className="exportables-buttons-container">
                        <div style={{ width: '100%' }} className="row">
                            <div className="exportables-buttons-container">
                                <FilterButton
                                    label={exportFilter?.PAP_COMMISSION}
                                    type={membershipsDatatable?.type}
                                    action={selectType}
                                />
                                <FilterButton
                                    label={exportFilter?.AFF_COMMISSION}
                                    type={membershipsDatatable?.type}
                                    action={selectType}
                                />
                            </div>

                            <div className="col-12 col-md-2" style={{ marginTop: '10px' }}>
                                <Select
                                    options={[{ name: '', _id: "" }, ...monthsComissionsOptions]}
                                    label={'Mes'}
                                    value={month}
                                    onChange={selectMonth}
                                />
                            </div>
                            <div className="col-12 col-md-2" style={{ marginTop: '10px' }}>
                                <Select
                                    options={[{ _id: "", name: "" }, ...Array.from({ length: new Date().getFullYear() - 2024 }, (_, i) => ({
                                        _id: (2025 + i).toString(),
                                        name: (2025 + i).toString(),
                                    }))]}
                                    label={'Año'}
                                    value={year}
                                    onChange={selectYear}
                                />
                            </div>
                            <div className="col-12 col-md-2" style={{ marginTop: '10px' }}>
                                <Select
                                    options={salesChannelOptions}
                                    label={'Canal'}
                                    value={saleChannel}
                                    onChange={selectSaleChannel}
                                />
                            </div>

                            {/* <div className="col-12 col-md-3" style={{ marginTop: '12px' }}>
                                <SelectPerPage
                                    label={'Registros por página'}
                                    options={itemsPerpage}
                                    value={membershipsDatatable?.limit}
                                    onChange={selectitemsPerpage}
                                />
                            </div> */}
                        </div>
                    </div>
                </div>


                {membershipsDatatable?.type === exportFilter?.PAP_COMMISSION && (
                    <PAPCommissionTable
                        header={PAPComissionTableHeader}
                        data={membershipsDatatable}
                        year={year}
                        month={month}
                        handlePageChange={handlePageChange}
                        action={redirectToDetail}
                        renewMembership={renewMembership}
                        tableRef={tableRef}
                    />
                )}
                {membershipsDatatable?.type === exportFilter?.AFF_COMMISSION && (
                    <CxCTable
                        header={AffiliationComissions}
                        data={membershipsDatatable}
                        handlePageChange={handlePageChange}
                        month={month}
                        year={year}
                        action={redirectToCommissionDetail}
                        renewMembership={renewMembership}
                        tableRef={tableRef}
                    />
                )}


            </div>
        </>
    );
};
